angular.module('app.directives').directive('addAttachment', () => ({
    restrict: 'E',

    scope: {
        model: '@',
        modelId: '@',
        allow: '@?',
        addClass: '@?',
        onComplete: '&?',
        changed: '=?',
    },

    controller($scope, $timeout, $translate, notify) {
        $scope.loaded = false;

        $scope.$watch('modelId', (modelId) => {
            if (0 < modelId && !$scope.loaded) {
                $scope.uploaderId = `uploader_${$scope.model}_${modelId}`;

                $timeout(() => {
                    const progressbar = $(`#${$scope.uploaderId}-progressbar`);
                    const bar = progressbar.find('.uk-progress-bar');
                    let info;

                    const settings = {
                        action: '/api/1/attachments',
                        single: false,
                        param: 'files[]',
                        params: {
                            model: $scope.model,
                            model_id: modelId,
                        },
                        allow: $scope.allow || '*.*',
                        loadstart() {
                            bar.css('width', '0%').text('0%');
                            progressbar.removeClass('uk-hidden');
                            notify.global(1);
                            info = notify.info($translate.instant('attachments.uploading'));
                        },
                        progress(percent) {
                            percent = Math.ceil(percent);
                            bar.css('width', `${percent}%`).text(`${percent}%`);
                        },
                        allcomplete(response) {
                            bar.css('width', '100%').text('100%');
                            notify.global(0);
                            info.close();
                            notify.success($translate.instant('attachments.uploaded'));

                            $timeout(() => {
                                progressbar.addClass('uk-hidden');
                            }, 250);

                            if ('function' === typeof $scope.onComplete) {
                                $scope.onComplete({ response });
                            }
                            $scope.changed = Math.round(1 + Math.random() * 99);
                        },
                    };

                    const select = UIkit.uploadSelect(angular.element(`#${$scope.uploaderId}-select`), settings);
                    const drop = UIkit.uploadDrop(angular.element(`#${$scope.uploaderId}-drop`), settings);

                    $scope.loaded = true;
                });
            }
        });

        // czekamy 2s
        $timeout(() => {
            $scope.loaded = true;
        }, 2000);
    },

    templateUrl: '/directives/attachment/add-attachment.html',
    transclude: false,
}));
